import React from "react";
import "./ScoringUsecase.css";

import pfm from "../../../assets/image/usecase/personal_finance_management.webp";
import ila from "../../../assets/image/usecase/instant_loan_approval.webp";
import dtl from "../../../assets/image/usecase/delightful_transaction_list.webp";
import cda from "../../../assets/image/usecase/credit_decisioning_automation.webp";
import bfm from "../../../assets/image/usecase/business_finance_management.webp";
const ScoringUsecases = () => {
  return (
    <section
      className="uc-section-1"
      style={{ marginBottom: "10vh" }}
      id="use-cases"
    >
      <div className="uc-section-2">
        <div>
          <p className="section-header">Use cases</p>
          <h2 className="section-h2">
            Power your fintech products with Genify
          </h2>
        </div>
        <div className="uc-grid">
          {/*grid*/}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            data-aos="fade-right"
            data-aos-duration="1300"
            data-aos-delay="700"
          >
            <div>
              <img
                src={cda}
                style={{ height: "13vh", marginRight: "23px", position: "relative" }}
                alt="credit decisioning automation"
              />
            </div>
            <div>
              {/*img */}
              <div></div> {/*spacer */}
              <h4 className="uc-section-h4">Credit Decisioning Automation</h4>
              <p className="uc-section-p">
                Encode your business rules and decision trees for automated
                lending decisioning.
              </p>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            data-aos="fade-right"
            data-aos-duration="1300"
            data-aos-delay="500"
          >
            <div>
              <img
                src={ila}
                style={{ height: "13vh", marginRight: "23px", position: "relative" }}
                alt="instant loan approval"
              />
            </div>
            <div>
              {/*img */}
              <div></div> {/*spacer */}
              <h4 className="uc-section-h4">Instant Loan Approval</h4>
              <p className="uc-section-p">
                {" "}
                Leverage the power of alternative data for underwriting.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScoringUsecases;
